module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/mobile_8844a1.jpg";